import Navigation from "./Navigation";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";
import logoBorneEtEaux from "../assets/img/logo-borne_et_eaux.png";
import loginPerson from "../assets/img/login-person.svg";
import { Link } from "react-router-dom";
import LanguageSelector from "./LanguageSelector";
import { Tooltip } from "react-tooltip";
import Modal from "./Modal";
import { useState } from "react";
import LoginCheck from "./loginCheck";
import LoadingOverlay from "./LoadingOverlay";
import Dropdown from "./Dropdown";
import VisuelRef from "../assets/img/visuel-ref.png";

const toolTipProps = {
    place: "top",
    className: "tooltip",
    effect: "solid",
    // border: true,
    backgroundColor: "#fff",
    borderColor: "#5e92ff",
    textColor: "#5e92ff",
    html: true,
};

export const DefaultLayout = ({ children }) => {
    return (
        <>
            <Navigation key="0" />
            <main id="main-content">
                <div className="container">{children}</div>
            </main>
            <Footer />
            <LoginCheck />
            <Tooltip {...toolTipProps} />
        </>
    );
};

export const LoginLayout = ({ children }) => {
    const { t } = useTranslation();

    return (
        <>
            <Navigation key="0" />
            <div className="login">
                <div className="login__wrapper">
                    <div className="login__logo">
                        <Link to="/login">
                            <img
                                src={logoBorneEtEaux}
                                alt="Logo Borne et Eaux"
                            />
                        </Link>
                    </div>
                    <div className="login__body">
                        <div className="login__intro">
                            <img src={loginPerson} alt="" />
                            <p>{t("login_intro")}</p>
                        </div>
                        <div className="login__entry">{children}</div>
                    </div>
                </div>
            </div>
            <Footer disableReplayButton />
            <Tooltip {...toolTipProps} />
        </>
    );
};

export const RegisterLayout = ({ children, step }) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const steps = [
        { number: 1, name: "identity", to: "/register" },
        { number: 2, name: "company", to: "/register/step2" },
        { number: 3, name: "informations", to: "/register/step3" },
        { number: 4, name: "connections", to: "/register/step4" },
        { number: 5, name: "good_to_know", to: "/register/step5" },
    ];

    return (
        <div className="register">
            <LanguageSelector />
            <div className="register__wrapper">
                <div className="register__logo">
                    <Link to="/">
                        <img src={logoBorneEtEaux} alt="Logo Borne et Eaux" />
                    </Link>
                </div>
                <div className="register__form-wrapper">
                    <h1 className="register__title">
                        {t("Create a shipowner account")}
                    </h1>
                    <ul className="steps">
                        {steps.map((s) => (
                            <li key={s.number}>
                                {s.number < step ? (
                                    <Link className="steps__step" to={s.to}>
                                        <span
                                            className={`steps__number steps__number--done`}
                                        >
                                            {s.number}
                                        </span>
                                        {t(s.name)}
                                    </Link>
                                ) : (
                                    <span className="steps__step">
                                        <span
                                            className={`steps__number${s.number === step ? " steps__number--active" : " steps__number--inactive"}`}
                                        >
                                            {s.number}
                                        </span>
                                        {t(s.name)}
                                    </span>
                                )}
                            </li>
                        ))}
                    </ul>
                    {children}
                    <Link className="register__backlink" to="/login">
                        {t("back_to_login")}
                    </Link>
                </div>
                <button
                    onClick={() => setOpen(true)}
                    type="button"
                    className="register__personal-data"
                >
                    <span className="vnf-icons-icon-m-information-solid"></span>
                    {t("about_personnal_data")}
                </button>
            </div>
            <Tooltip {...toolTipProps} />

            <Modal open={open} size="lg" onClose={() => setOpen(false)}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: t("HTML__personnal_data", {
                            interpolation: { escapeValue: false },
                        }),
                    }}
                ></div>
                <div className="modal__buttons modal__buttons--center">
                    <button
                        onClick={() => setOpen(false)}
                        className="vnf-btn vnf-btn-primary vnf-btn-m vnf-btn-similar-color vnf-btn-bleu-a2 vnf-btn-box-shadow-bleu-a4"
                    >
                        {t("close")}
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export const BoaterLayout = ({
    children,
    step,
    loading,
    terminalName,
    blueBackground = false,
}) => {
    const { t } = useTranslation();

    const steps = [
        { number: 0, name: "boater_process_intro", to: "/boater" },
        {
            number: 1,
            name: "boater_process_terminal_choice",
            to: "/boater/step1",
        },
        { number: 2, name: "boater_process_user_info", to: "/boater/step2" },
        { number: 3, name: "boater_process_bank_auth", to: "/boater/step3" },
        { number: 4, name: "boater_process_charging", to: "/boater/step4" },
    ];

    const currentStep = steps.find((s) => s.number === step);

    const altHeader =
        terminalName && (currentStep.number === 1 || currentStep.number === 4);

    return (
        <>
            <Navigation key="0" isBoater />
            <div
                className={`boater${blueBackground ? " boater--blue-background" : ""}`}
            >
                <LoadingOverlay
                    active={!!loading}
                    classNamePrefix="loader_"
                    spinner
                    text={t("loading")}
                />
                <div
                    className={`boater__wrapper${currentStep.number === 0 ? "-intro" : ""}`}
                >
                    {currentStep.number === 0 ? (
                        <div className="boater__step-header__intro">
                            <div className="boater__step-header__logo">
                                <Link to="/login">
                                    <img
                                        src={logoBorneEtEaux}
                                        alt="Logo Borne et Eaux"
                                    />
                                </Link>
                            </div>
                            <h1 className="boater__step-title__intro">
                                {t(currentStep.name)}
                            </h1>
                            <div className="boater__step-header__intro-text">
                                {t("boater_process_intro_text")}
                            </div>
                        </div>
                    ) : (
                        <div
                            className={`boater__step-header__steps ${altHeader ? "step-header-alt" : ""}`}
                        >
                            <span>{currentStep.number}</span>
                            <h1 className={`boater__step-title__steps`}>
                                {terminalName &&
                                (currentStep.number === 1 ||
                                    currentStep.number === 4) ? (
                                    <>
                                        <span>
                                            {t("boater_process_terminal")}
                                        </span>{" "}
                                        {terminalName}
                                    </>
                                ) : (
                                    t(currentStep.name)
                                )}
                            </h1>
                            {terminalName &&
                                (currentStep.number === 1 ||
                                    currentStep.number === 4) && (
                                    <Dropdown buttonText={t("find_reference")}>
                                        <div>
                                            <img
                                                src={VisuelRef}
                                                width="215"
                                                height="130"
                                                alt=""
                                            />
                                        </div>
                                    </Dropdown>
                                )}
                        </div>
                    )}
                    <div
                        className={`boater__step-wrapper ${altHeader ? "step-wrapper-alt" : ""}`}
                    >
                        {step === 0 && (
                            <ul className="boater__step-list">
                                {steps.map((s) => {
                                    if (s.number === 0) return null;
                                    return (
                                        <li
                                            key={s.number}
                                            className="boater__step-list__item"
                                        >
                                            <span className="boater__step-list__number">
                                                {s.number}
                                            </span>
                                            <span className="boater__step-list__name">
                                                {t(s.name)}
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        {children}
                    </div>
                </div>

                <Tooltip {...toolTipProps} />
            </div>
        </>
    );
};
